import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';

export function isPointInConvexPolygon(point: IXY, polygon: IXY[]) {
    const x = point.x,
        y = point.y;

    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].x,
            yi = polygon[i].y;
        const xj = polygon[j].x,
            yj = polygon[j].y;

        const intersect = yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }

    return inside;
}

export function isPointInCircle(point: IXY, center: IXY, radius: number) {
    const centerToPointDistance = Math.pow(center.x - point.x, 2) + Math.pow(center.y - point.y, 2);
    const centerToRadiusDistance = Math.pow(radius, 2);

    return centerToPointDistance < centerToRadiusDistance;
}
